import styled from "styled-components";

export const Container = styled.div`
  max-width: 920px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  margin: 0 0 2.5rem;
  font-size: clamp(2rem, 4vw, 3rem);
  line-height: 1.15;
`;

export const SkillGroup = styled.div`
  & + & {
    margin-top: 2.5rem;
  }
`;

export const GroupTitle = styled.h3`
  margin: 0 0 1rem;
  font-size: 1.2rem;
  font-weight: 600;
`;

export const SkillList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Skill = styled.li`
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  padding: 0.65rem 1rem;
  color: #ffffff;
  font-size: 0.98rem;
  line-height: 1.2;
`;
